import { Box, Grid, Skeleton } from '@mui/material';

const VideoHintsSkeleton = () => {
    return (
        <Grid
            container
            flexDirection={'column'}
            sx={{
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '100%',
                marginY: '20px',
                paddingX: '20px',
            }}
        >
            <Grid
                item
                sx={{
                    width: '100%',
                }}
            >
                <Grid container flexDirection={'column'} alignItems={'center'}>
                    <Grid item>
                        <Skeleton width={150} height={40} />
                        <Box sx={{ marginY: '1rem' }}>
                            <Skeleton
                                variant="circular"
                                height={150}
                                width={150}
                                sx={{ margin: 'auto' }}
                            />
                        </Box>
                    </Grid>
                    <Grid item sx={{ width: '100%', maxHeight: "32svh", overflowY: 'auto' }}>
                        <Grid container gap={'10px'} sx={{ width: '100%', height: "100%" }}>
                            {[...Array(4)].map((index: number) => (
                                <Grid
                                    item
                                    sx={{
                                        width: '100%',
                                        height: 'fit-content',
                                    }}
                                >
                                    <Skeleton
                                        width="100%"
                                        height={70}
                                        key={index}
                                        sx={{ transform: 'unset' }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Box sx={{ width: '100%', marginBottom: "40px" }}>
                <Skeleton width="100%" height={50} sx={{ transform: 'unset' }} />
            </Box>
        </Grid>
    );
};

export default VideoHintsSkeleton;
